import React from 'react'
import clsx from 'clsx'
import { useTheme } from '@mui/material'
import {
  CREDITO_TEXTO,
  CREDITO_EMPRESA,
  CREDITO_MARCA_HOSPEDAGEM,
  SITE_EMPRESA,
  SITE_EMPRESA_ROTULO
} from '../../libs/marca'

// Crédito da casa. Segue a linguagem visual usada nos sites institucionais da
// GLA — caixa alta, tracking largo, corpo pequeno e a bolinha verde pulsante
// de "no ar" — só que aqui com o texto do produto.
//
// `claro` = usado sobre fundo escuro (o painel da tela de entrada).

export default function CreditoGLA({ claro = false, className = '' }) {
  const theme = useTheme()
  // Crédito é fineprint: não pode competir com a marca nem com o formulário.
  const corTexto = claro ? 'rgba(255,255,255,0.62)' : theme.palette.text.secondary
  const corDestaque = claro ? 'rgba(255,255,255,0.9)' : theme.palette.text.primary

  return (
    <div
      className={clsx(
        'flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 w-full',
        className
      )}
      style={{ color: corTexto }}
    >
      <p
        className="text-[10px] sm:text-[11px] uppercase text-center sm:text-left leading-relaxed m-0"
        style={{ letterSpacing: '0.14em' }}
      >
        {CREDITO_TEXTO}{' '}
        <a
          href={SITE_EMPRESA}
          target="_blank"
          rel="noopener noreferrer"
          className="foco-navegacao underline underline-offset-2 decoration-transparent hover:decoration-inherit transition-colors"
          style={{ color: corDestaque, fontWeight: 600 }}
        >
          {CREDITO_EMPRESA}
        </a>{' '}
        ({CREDITO_MARCA_HOSPEDAGEM})
      </p>

      <a
        href={SITE_EMPRESA}
        target="_blank"
        rel="noopener noreferrer"
        className="foco-navegacao flex items-center gap-2 text-[10px] sm:text-[11px] uppercase whitespace-nowrap"
        style={{ letterSpacing: '0.14em', color: corTexto }}
      >
        <span className="relative flex h-2 w-2 flex-none" aria-hidden="true">
          <span
            className="absolute inline-flex h-full w-full rounded-full animate-ping"
            style={{ backgroundColor: '#22C55E', opacity: 0.6 }}
          />
          <span
            className="relative inline-flex rounded-full h-2 w-2"
            style={{ backgroundColor: '#22C55E' }}
          />
        </span>
        {SITE_EMPRESA_ROTULO}
      </a>
    </div>
  )
}
